import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IContactHubProps } from './ContactHubTypes';
import { ContactHub } from './ContactHub';

export const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IContactHubProps = elementAttributesToProps(domNode);

  return Promise.resolve(<ContactHub {...props} />);
};

export default rehydrator;
